import React, { useEffect } from 'react';
import '../styles/main.css';
import About from './about';
import Projects from './projects';
import Skills from './skills';

const Main: React.FC = () => {
  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = (element as HTMLElement).getBoundingClientRect().top;
        const elementVisible = 150;
        if (elementTop < windowHeight - elementVisible) {
          element.classList.add('active');
          element.classList.remove('hide');
        } else {
          element.classList.add('hide');
          element.classList.remove('active');
        }
      });
    };
    window.addEventListener('scroll', reveal);
    return () => window.removeEventListener('scroll', reveal);
  }, []);

  return (
    <div className="main-content">
      <Projects />
      <Skills />
    </div>
  );
};

export default Main;
